export type Cards = Array<string>;
export const CARDS = "cards";
